import React from "react";
import Collapsible from "react-collapsible";

import Socials from "./blocks/editable/Socials";

import PortalModal from "./modal/PortalModal";

import LinkSelect from "./LinkSelect";
import ColorPicker from "./ColorPicker";
import Border from "./Border";

import Backend from "../utils/Backend";
import General from "../utils/General";
import Navigation from "../utils/Navigation";

import SmartList from "./common/SmartList";
import Toggle from "./sectioninputs/Toggle";
import H3 from "./blocks/editable/H3";
import P from "./blocks/editable/P";
import Event from "../utils/Event";
import { renderDragIcon } from "../utils/renderDragIcon";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      canRenderContent: props.canRenderContent,
      website: props.website,
      data: props.footer,
      editable: props.editable,
      disableSubmit: false,
      newsletterEmailValue: ""
    };

    this.updateFooter = General.debounce(
      () => {
        console.log("3333", this.state.data);
        Backend.updateFooter(this.state.data);
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup();
    Event.on('FOOTER_UPDATED', (footer) => this.setState({
      data: footer
    }));
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  _setup() {
    let { data, website } = this.state;

    this.setState({
      data,
      loading: false,
    });
  }

  _update(data, callback) {
    this.setState({ data }, () => {
      if (callback) {
        callback();
      }
      this.updateFooter();
    });
  }

  _addColumnItem(data) {
    data.columns.push({
      title: "Column",
      nav_items: [],
    });

    this._update(data);
  }

  _addNavItem(data, colIndex) {
    data.columns[colIndex].nav_items.push({
      text: "New Link",
      url: "#",
      active: true,
      nav_items: [],
      open_in_new_tab: false,
    });

    this._update(data);
  }

  _renderModal() {
    let { data, showModal } = this.state;
    return (
      <PortalModal
        show={showModal}
        onHide={() => this.setState({ showModal: false })}
      >
        <h2>Footer</h2>

        <>
          <Border>
            <Collapsible trigger="Footer Style">
              <br></br>

              <select
                value={data.variation || "standard"}
                onChange={(event) => {
                  data.variation = event.target.value;

                  if (data.columns.length === 0) {
                    data.columns = [
                      {
                        title: `Column Title ${data.columns.length + 1}`,
                        nav_items: [],
                      },
                    ];
                  }
                  this._update(data);
                }}
              >
                <option value="small">Small Footer</option>
                <option value="standard">Large Footer</option>
              </select>
            </Collapsible>
          </Border>

          <Border>
            <Collapsible
              trigger={
                this.isSmallFooter()
                  ? "What Links Would You Like To Show?"
                  : "How Many Columns Would You Like?"
              }
            >
              <br></br>
              {!this.isSmallFooter() && (
                <>
                  <select
                    value={data.columns.length}
                    onChange={(event) => {
                      let num = event.target.value;
                      let difference = num - data.columns.length;
                      if (difference > 0) {
                        for (var i = 0; i < difference; i++) {
                          data.columns.push({
                            title: `Column Title ${data.columns.length + 1}`,
                            nav_items: [],
                          });
                        }
                      } else if (difference < 0) {
                        for (var i = difference; i < 0; i++) {
                          data.columns.pop();
                        }
                      }
                      this._update(data);
                    }}
                  >
                    <option value="0">0 Columns</option>
                    <option value="1">1 Column</option>
                    <option value="2">2 Columns</option>
                    <option value="3">3 Columns</option>
                    <option value="4">4 Columns</option>
                  </select>
                  <br />
                </>
              )}

              {this.isSmallFooter() ? (
                this._renderModalSmallFooterLinks(data)
              ) : (
                <>
                  <br />
                  {this._renderModalColumns(data)}
                </>
              )}
            </Collapsible>
          </Border>
        </>

        {this._renderSocialInputs(data)}

        <Border>
          <Collapsible trigger="Colors">
            <br></br>

            <ColorPicker
              title={"Text Color"}
              color={data.settings.primary_color}
              onColorSelected={(color) => {
                data.settings.primary_color = color;
                this._update(data);
              }}
            />

            <br />

            <ColorPicker
              title={"Background Color"}
              color={data.settings.tertiary_color}
              onColorSelected={(color) => {
                data.settings.tertiary_color = color;
                data.settings.msc_enabled = false
                this._update(data);
              }}
            />
          </Collapsible>
        </Border>
      </PortalModal>
    );
  }

  _renderSocialInputs(data) {
    if (data.socials == null) {
      data.socials = {
        settings: {},
      };
    }

    return (
      <Border>
        <Collapsible trigger="Social Links & Fine Print">
          <br></br>
          <span>Fine Print</span>
          <input
            type="text"
            defaultValue={data.fine_print}
            onChange={(event) => {
              data.fine_print = event.target.value;
              this._update(data);
            }}
          />
          <br />
          <br />
          {this._renderSocialInput("Email", "mail", data.socials.mail, data)}
          {this._renderSocialInput(
            "Website",
            "website",
            data.socials.website,
            data
          )}
          {this._renderSocialInput(
            "Twitter",
            "twitter",
            data.socials.twitter,
            data
          )}
          {this._renderSocialInput(
            "Instagram",
            "instagram",
            data.socials.instagram,
            data
          )}
          {this._renderSocialInput(
            "Facebook",
            "facebook",
            data.socials.facebook,
            data
          )}
          {this._renderSocialInput(
            "LinkedIn",
            "linkedIn",
            data.socials.linkedIn,
            data
          )}
        </Collapsible>
      </Border>
    );
  }

  _renderSocialInput(title, key, value, data) {
    return (
      <>
        <span>{title}</span>
        <input
          type="text"
          defaultValue={value}
          onChange={(event) => {
            data.socials[key] = event.target.value;
            this._update(data);
          }}
        />
        <br />
        <br />
      </>
    );
  }

  _renderModalColumns(data) {
    let color = data.settings.primary_color;
    let containNewsLetter = !data.columns.find(one => one?.newsletter_settings?.show_news_letter);
    return (
      <>
        <SmartList
          title="Columns"
          canDelete={false}
          items={data.columns}
          itemName="Column"
          value={(column) => column.title}
          renderItem={(column, index) => {
            return (
              <Collapsible
                trigger={data.columns[index].title}
              >
                {renderDragIcon({}, "absolute")}
                <br />
                {(column?.newsletter_settings?.show_news_letter || containNewsLetter) && <Toggle
                    id={`news_letter_toggle ${index}`}
                    checked={column?.newsletter_settings?.show_news_letter || false}
                    title="Show Newsletter"
                    onChange={checked => {
                      if (!data.columns[index]["newsletter_settings"]) {
                        data.columns[index]["newsletter_settings"] = {};
                      }
                      data.columns[index]["newsletter_settings"].show_news_letter = checked;
                      this._update(data)
                    }}
                />}
                <div className="boxed boxed--border">
                  <a
                    className="delete-item"
                    onClick={() => {
                      data.columns.splice(index, 1);
                      this._update(data);
                    }}
                  />
                  {column?.newsletter_settings?.show_news_letter ? <div className="pt-4">
                    <Toggle
                      id={`news_letter_title ${index}`}
                      checked={column.newsletter_settings.news_letter_title || false}
                      title="Large Text Heading"
                      onChange={checked => {
                        if (!data.columns[index]["newsletter_settings"]) {
                          data.columns[index]["newsletter_settings"] = {};
                        }
                        data.columns[index]["newsletter_settings"].news_letter_title = checked;
                        this._update(data)
                      }}
                    />
                    <Toggle
                      id={`news_letter_subtitle ${index}`}
                      checked={column.newsletter_settings.news_letter_subtitle || false}
                      title="Small Description Text Line"
                      onChange={checked => {
                        if (!data.columns[index]["newsletter_settings"]) {
                          data.columns[index]["newsletter_settings"] = {};
                        }
                        data.columns[index]["newsletter_settings"].news_letter_subtitle = checked;
                        this._update(data)
                      }}
                    />
                    <span>Email Placeholder</span>
                    <input
                      type="text"
                      defaultValue={column?.newsletter_settings?.news_letter_placeholder}
                      onChange={(event) => {
                        if (!data.columns[index]["newsletter_settings"]) {
                          data.columns[index]["newsletter_settings"] = {};
                        }
                        data.columns[index]["newsletter_settings"].news_letter_placeholder = event.target.value;
                        this._update(data);
                      }}
                    />
                    <br />
                    <br />
                    <span>Submit Message</span>
                    <input
                      type="text"
                      defaultValue={column?.newsletter_settings?.news_letter_submit_message}
                      onChange={(event) => {
                        if (!data.columns[index]["newsletter_settings"]) {
                          data.columns[index]["newsletter_settings"] = {};
                        }
                        data.columns[index]["newsletter_settings"].news_letter_submit_message = event.target.value;
                        this._update(data);
                      }}
                    />
                  </div> : <div className="ml-auto">
                    <span>Column Title</span>
                    <input
                      type="text"
                      defaultValue={column.title}
                      onChange={(event) => {
                        data.columns[index].title = event.target.value;
                        this._update(data);
                      }}
                    />
                    <br />
                    <br />
                    <span>Links</span>
                    <div style={{ marginBottom: 0 }}>
                      <br />
                      {this._renderModalNavItems(data, index, column.nav_items)}
                      {this._renderModalAddNavItemButton(data, index)}
                    </div>
                  </div>}
                </div>
              </Collapsible>
            );
          }}
          onUpdated={(columns) => {
            data.columns = columns;

            this._update(data);
          }}
        />
      </>
    );
  }

  _renderModalSmallFooterLinks(data) {
    let color = data.settings.primary_color;

    let column = data.columns[0];

    let index = 0;

    return (
      <>
        <div className="boxed boxed--border">
          <div className="ml-auto">
            <span>Links</span>
            <div style={{ marginBottom: 0 }}>
              <br />
              {this._renderModalNavItems(data, index, column.nav_items)}
              {this._renderModalAddNavItemButton(data, index)}
            </div>
          </div>
        </div>
      </>
    );
  }

  _renderModalNavItems(data, colIndex, navItems) {
    return (
      <SmartList
        title="Links"
        canDelete={false}
        items={navItems}
        itemName="Link"
        value={(navItem) => navItem.text}
        renderItem={(navItem, index) => {
          return (
            <Collapsible
              trigger={navItem.text}
              className="mb--1"
              overflowWhenOpen="visible"
              triggerSibling={() => {
                return (
                  <a
                    className="delete-item delete-item-collapsible"
                    onClick={() => {
                      Backend.updateCCPageLinks(General.clone(navItem), "footer")
                      data.columns[colIndex].nav_items.splice(index, 1);
                      this._update(data);
                    }}
                  />
                );
              }}
            >
              <div className="boxed boxed--sm overflow-visible">
                <span>Title</span>
                <input
                  type="text"
                  defaultValue={navItem.text}
                  onChange={(event) => {
                    let text = event.target.value;
                    navItem.text = text;
                    data.columns[colIndex].nav_items[index] = navItem;
                    this._update(data);
                  }}
                />
                <br />
                <br />
                <span>Link</span>
                <LinkSelect
                  type={"footer"}
                  url={navItem.url}
                  onUpdated={(url, ccPageId) => {
                    navItem.url = url;
                    navItem.cc_page_id = ccPageId;
                    data.columns[colIndex].nav_items[index] = navItem;
                    this._update(data);
                  }}
                />

                {!navItem.url?.startsWith("/#") && (
                  <>
                    <span>Open In New Tab</span>
                    <select
                      className="mb-3"
                      value={navItem.open_in_new_tab}
                      onChange={(event) => {
                        navItem.open_in_new_tab = event.target.value === "true";

                        data.columns[colIndex].nav_items[index] = navItem;

                        this._update(data);
                      }}
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </>
                )}
              </div>
            </Collapsible>
          );
        }}
        onUpdated={(navItems) => {
          data.columns[colIndex].nav_items = navItems;

          this._update(data);
        }}
      />
    );
  }

  _renderModalAddColumnButton(data) {
    return (
      <div className="row">
        <div className="col-md-12">
          <a className="btn" onClick={() => this._addColumnItem(data)}>
            <span className="btn__text">Add Column</span>
          </a>
        </div>
      </div>
    );
  }

  _renderModalAddNavItemButton(data, colIndex) {
    return (
      <div className="row">
        <div className="col-md-12">
          <a className="btn" onClick={() => this._addNavItem(data, colIndex)}>
            <span className="btn__text">
              {this.isSmallFooter() ? "Add New Link" : "Add Column Link"}
            </span>
          </a>
        </div>
      </div>
    );
  }

  _renderEditable(editable) {
    if (!editable) {
      return null;
    }

    return (
      <>
        <div className="nav-button-edit">
          <div className="button-slide">
            <a
              className="button"
              href="javascript:void(0)"
              onClick={() => {
                this.setState({ showModal: true });
              }}
            >
              <span className="slide-text">Edit Footer</span>
              <i className="material-icons m-icon-s1 c-white-opa-8">settings</i>
            </a>
          </div>
        </div>
        {this._renderModal()}
      </>
    );
  }

  _renderNavItems(navItems) {
    let { data } = this.state;

    if (this.isSmallFooter()) {
      return (
        <div className="row mt-0">
          {navItems?.map((navItem) => {
            const navItemUrl = Navigation.getUrl(navItem.url, navItem.cc_page_id)
            return (
              <div className="col">
                <a
                  href={navItemUrl}
                  target={navItem.open_in_new_tab ? "_blank" : ""}
                  onClick={() => {
                    if (!navItem.open_in_new_tab) {
                      General.setLocationHref(navItemUrl)
                    }
                  }}
                  style={{
                    color: data.settings.primary_color,
                  }}
                >
                  {navItem.text}
                </a>
              </div>
            );
          })}
        </div>
      );
    }
    return navItems?.map((navItem) => {
      const navItemUrl = Navigation.getUrl(navItem.url, navItem.cc_page_id)
      return (
        <div>
          <a
            target={navItem.open_in_new_tab ? "_blank" : ""}
            href={navItemUrl}
            onClick={() => {
              if (!navItem.open_in_new_tab) {
                General.setLocationHref(navItemUrl)
              }
            }}
            style={{
              color: data.settings.primary_color,
            }}
          >
            {navItem.text}
          </a>
        </div>
      );
    });
  }

  _renderColumns(data) {
    if (!data.columns) {
      return null;
    }
    const colCount = data.columns.length;
    const layoutClass =
      colCount === 1 ? "single-column" : colCount > 1 ? "multiple-columns" : "";

    let colWeight = colCount < 4 ? 4 : 3;
    let className = "col-md-" + colWeight + " m-b-50";
    let columns = data.columns.map((column, index) => {
      return column?.newsletter_settings?.show_news_letter
        ? (
          <div className="newsletter">
            {this._renderNewsletter(data, column, index)}
          </div>
        ) : (
          <div className={className}>
            <h5 style={{ color: data.settings.primary_color }}>{column.title}</h5>
            {this._renderNavItems(column.nav_items)}
          </div>
        );
    });

    return <div className={`row footer-row ${layoutClass}`}>{columns}</div>;
  }

  _handleNewsletterSubmit(submitMessage) {
      const { newsletterEmailValue } = this.state;
      if (!newsletterEmailValue.trim()) {
        return
      }
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      if (!emailRegex.test(newsletterEmailValue?.trim())) {
        return
      }
      const params = {}
      const sessionId = sessionStorage.getItem("ccExternalSessionId")
      if (sessionId) {
        params[sessionId] = sessionId
      }
      params.emailAddress = newsletterEmailValue;
      params.salesUrl = window?.location?.href || ""
      params.userAgent = window?.navigator?.userAgent || ""
      params.campaignId = window?.CURRENT_WEBSITE?.campaign_id || ""
      this.setState({
        disableSubmit: true
      })
      Backend.submitLead(params).then((_) => {
        General.showNotification(submitMessage, true)
        this.setState({
          newsletterEmailValue: ""
        })
      }).catch((_) => {
        General.showNotification("Please try again.", false)
      }).finally(() => {
        this.setState({
          disableSubmit: false
        })
      })
  }

  _renderNewsletter(data, column, index) {
    return (
      <div>
        {column?.newsletter_settings?.news_letter_title ? <H3
          text={ column.news_title || "Subscribe to our Newsletter"}
          color={ data.settings.primary_color }
          editable={ this.state.editable }
          onUpdated={text => {
            data.columns[index].news_title = text;
            this._update(data)
          }}
        /> : null}
        {column?.newsletter_settings?.news_letter_subtitle ? <P
          text={ column.news_subtitle || "Get the latest updates right in your inbox"}
          color={ data.settings.primary_color }
          editable={ this.state.editable }
          className="like-pre"
          onUpdated={text => {
            data.columns[index].news_subtitle = text;
            this._update(data)
          }}
        />: null}
        <div>
          <form method="POST" onSubmit={(event) => {
            event.preventDefault()
            this._handleNewsletterSubmit(column?.newsletter_settings?.news_letter_submit_message || "Saved")
          }}>
            <div className="custom-input-container">
              <input
                type="email"
                value={this.state.newsletterEmailValue}
                placeholder={column?.newsletter_settings?.news_letter_placeholder || "Your Email"}
                className="custom-input"
                onChange={(event) => {
                  this.setState({
                    newsletterEmailValue: event.target.value
                  })
                }}
                aria-required="true"
                autocorrect="off"
                autocapitalize="off"
                autocomplete="email"
                required="true"
              />
              <button disabled={this.state.disableSubmit} className="custom-input-arrow" aria-label="Submit Email">
                &rarr;
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
  _renderFinePrint(data) {
    let navItems = data.columns[0]?.nav_items;

    let colClassName = this.isSmallFooter() ? "col-sm-4" : "col-sm-6";
    return (
      <div className="row">
        <div className={colClassName}>
          <span
            className="type--fine-print"
            style={{
              color: data.settings.primary_color,
            }}
          >
            {data.fine_print}
          </span>
        </div>
        <div
          className={`${colClassName} ${
            this.isSmallFooter() ? "text-sm-center" : "text-sm-right"
          }`}
        >
          <Socials socials={data.socials} color={data.settings.primary_color} />
        </div>

        {this.isSmallFooter() && (
          <div className={`${colClassName} text-sm-right`}>
            {this._renderNavItems(navItems)}
          </div>
        )}
      </div>
    );
  }

  isSmallFooter() {
    let isSmallFooter = this.state.data.variation == "small";
    return isSmallFooter;
  }

  render() {
    let { data, editable, website } = this.state;

    let className = "space--sm footer-2 bg--primary";
    if (
      data.columns == null ||
      data.columns.length === 0 ||
      this.isSmallFooter()
    ) {
      className = "footer-7 text-center-xs bg--primary";
    }

    if (website.hide_footer || this.props.hideFooter) {
      return null;
    }

    if (data.settings.msc_enabled) {
      data.settings.tertiary_color = window.CURRENT_PAGE_PRIMARY_COLOR;
    }

    return (
      <footer
        className={className + " section-footer "}
        style={{
          backgroundColor: data.settings.tertiary_color,
        }}
      >
        <div className="container">
          {!this.isSmallFooter() && this._renderColumns(data)}
          {this._renderFinePrint(data)}
        </div>
        {this._renderEditable(editable)}
      </footer>
    );
  }
}
